import React from 'react'

export default props => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 7"
    style={{ transform: 'none' }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.926 5.09 15.767 0l1.344 1-8.063 6-.122-.09L10.15 6l-1.223-.91Zm0 0L2.085 0 .74 1l8.064 6 .121-.09L7.704 6l1.222-.91Z"
      fill="#273754"
    />
  </svg>
)
